import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { serverURL } from '../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../config/firebase-logging';
import jwt_decode from "jwt-decode";
import "../styles/auth-forms.css"
import { useCareerContext } from './career-context';


function SignIn() {
    const { handleError } = useCareerContext();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    function handleLocalSignIn(e) {
        setIsLoading(true);
        e.preventDefault();
        fetch(serverURL + "/login",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: e.target[0].value.toLowerCase(), password: e.target[1].value })
            })
            .then(response => response.json())
            .then(data => {
                const { error, message } = data;
                if (error) {
                    handleError(message)
                } else {
                    if (process.env.REACT_APP_ENVIRONMENT === "production") {
                        logEvent(analytics, 'login')
                    }
                    localStorage.setItem('token', data.token)
                    navigate("/");
                    window.location.reload();

                }
                setIsLoading(false);
            })
            .catch(err => {
                handleError("An unknown error occurred")
                if (process.env.REACT_APP_ENVIRONMENT === "production") {
                    logEvent(analytics, 'error', { error_message: "login_error: " + err.message })
                }
                setIsLoading(false);
            })
    }

    return (
        <div className='auth container col' style={{ textAlign: "center" }}>
            <h1>Log into your account</h1>
            <h3 className='gray' style={{ fontFamily: "'Roboto', sans-serif" }}>Don't have an account? <a href="/signup" className='green'>Sign Up</a></h3>
            <div className='form-wrapper col'>
                <form className=' col' onSubmit={handleLocalSignIn}>

                    <div className='form-group col'>
                        <label>Email <span className='red'>*</span></label>
                        <input type='text' required />
                    </div>
                    <div className='form-group col'>
                        <label>Password <span className='red'>*</span></label>
                        <input type='password' required />
                    </div>
                    <div className='form-group row' style={{ justifyContent: 'flex-end' }}>
                        <a className='green'>Forgot Password?</a>
                    </div>
                    <button style={{backgroundColor: isLoading ? "#89cf89" : "#42b342", cursor: isLoading ? "not-allowed" : "pointer"}} disabled={isLoading}>Sign In</button>
                </form>
                <p style={{ margin: "15px 0px" }}>Or</p>
                <GoogleLogin
                    width="350px"
                    size="large"
                    theme="filled_blue"
                    onSuccess={credentialResponse => {
                        const data = jwt_decode(credentialResponse.credential);
                        fetch(serverURL + "/auth/google", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ email: data.email, name: data.name })
                        })
                            .then(response => response.json())
                            .then(data => {
                                const { error, message } = data;
                                if (error) {
                                    handleError(message)
                                } else {
                                    if (process.env.REACT_APP_ENVIRONMENT === "production") {
                                        logEvent(analytics, 'login')
                                    }
                                    localStorage.setItem('token', data.token)
                                    navigate("/");
                                    window.location.reload();
                                }
                            })
                            .catch(err => {
                                if (process.env.REACT_APP_ENVIRONMENT === "production") {
                                    logEvent(analytics, 'error', { error_message: "login_error: " + err.message })
                                }
                                handleError("An unknown error occurred")
                            })
                    }}
                    onError={() => {
                        handleError("Login failed")
                    }}
                />
            </div>

        </div>

    );
}

export default SignIn;